<li class="nav-item dropdown" dropdown #dropdown="bs-dropdown" (mouseleave)="dropdown.hide()">
  <a href="#" dropdownToggle class="nav-link dropdown-toggle" (mouseenter)="dropdown.show()" routerLink="/registration">Enroll</a>
  <ul *dropdownMenu class="dropdown-menu" role="menu">
    <li role="menuitem"><a class="dropdown-item" href="#" routerLink="/registration/group">Group Lessons</a></li>
    <li role="menuitem"><a class="dropdown-item" href="#" routerLink="/registration/private">Private Lessons</a></li>
  </ul>
</li>
